import alt from '../alt'
import { post, del, getToken } from '../core/HttpClient'
import FormActions from './FormActions'


class BookingActions {
  constructor () {
    this.generateActions(
      'fetchedBookings'
    )
  }

  fetchBookings () {
    return (dispatch) => {
      dispatch()

      post('/bookings/search', [{ externalUserId: getToken() }])
        .then(res => {
          if (res) {
            console.log(res)
            this.fetchedBookings(res)
          }
        })
        .catch(err => console.log('BookingActions.fetchBookings.err', err))
    }
  }

  removeBooking (id) {
    return (dispatch) => {
      dispatch()

      del(`/bookings/${id}`)
        .then(res => {
          if (res.success) {
            this.fetchBookings()
          }
        })
        .catch(err => {
          FormActions.displayErrorMessage(err.message)
        })
    }
  }
}

module.exports = alt.createActions(BookingActions)



// WEBPACK FOOTER //
// ./src/actions/BookingActions.js